import { useInView } from 'framer-motion'
import React, { useEffect } from 'react'

import useEvent from './useEvent'

function useInViewCallback(ref: React.RefObject<Element>, callback?: () => void): void {
  const isInView = useInView(ref)

  const memorizedCallback = useEvent(callback)

  useEffect(() => {
    if (isInView && memorizedCallback != null) {
      memorizedCallback()
    }
  }, [isInView, memorizedCallback])
}

export default useInViewCallback
